export default "assets/images/excluded-9b427d72.svg";